// The one parameterised duration clamp. Both the Playground practice-length
// slider (1–5 min) and the Storytelling take-length picker (3–15 min) clamp a
// user-supplied minutes value to a closed integer range, rounding fractional
// inputs and falling back to a default on a non-finite input. They are the
// SAME algorithm with different constants, so they both delegate here.
//
// `clampDuration(value, min, max, fallback)`:
//   • non-finite (NaN / ±Infinity) → `fallback`
//   • otherwise rounds to the nearest integer, then clamps into `[min, max]`.

/**
 * Clamp an arbitrary number to a closed integer range, returning `fallback`
 * for non-finite input. Fractional inputs are rounded to the nearest integer
 * before clamping so the result is always a whole number inside `[min, max]`.
 */
export function clampDuration(
  value: number,
  min: number,
  max: number,
  fallback: number,
): number {
  if (!Number.isFinite(value)) return fallback;
  const rounded = Math.round(value);
  if (rounded < min) return min;
  if (rounded > max) return max;
  return rounded;
}
